import React, {useMemo, useRef, useState} from "react";
import {Badge} from "antd";
import {Link, useSearchParams} from "react-router-dom";
import {useOpportunity} from "../../../providers/OpportunityProvider";
import OppRejectionFeedbackModal from "../../talent-opportunities/components/OppRejectionFeedbackModal";
import Modal from "../../../components/Modal";
import UserImageCircle from "../../../components/UserImageCircle";

const CollapseTeamsHeader = ({teamOpp, isActive, onToggle}) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const {
        onShowInterest,
        onWithdraw,
        onRemoveInterest,
        onRejectForAgency,
        isDisabled
    } = useOpportunity();

    const rejectModal = useRef(null)
    const [showRejection, setShowRejection] = useState(false);


    const isAvailable = !teamOpp.is_dead && !teamOpp.job_candidate?.talent_rejected_at && !teamOpp.job_candidate?.talent_withdrew_at;
    const toggleRejectionModal = () => {
        return rejectModal?.current?.showModal()
    }
    const rejectOpp = (model) => {
        if (!teamOpp.isAvailable() || !teamOpp.can_be_rejected) {
            return;
        }

        return onRejectForAgency(teamOpp, {...model, for_team: true})
    }

    const withdrawOpp = (model) => {
        if (!teamOpp.isAvailable() || !teamOpp.can_be_withdrawn) {
            return;
        }
        return onWithdraw(teamOpp, {...model, for_team: true})
    }

    const editProposalDisabled = !teamOpp || teamOpp.is_dead || !teamOpp.job_candidate?.has_confirmed_scope
    // has_shown_interest_in_job
    // has_signable_contract
    // can_be_accepted
    // can_be_rejected
    // can_be_withdrawn
    // has_signable_contract
    // has_shown_interest_in_job
    // is_match
    // can_show_interest_in_job
    // can_remove_interest_in_job
    // status
    // accepted_at
    // rejected_at
    // withdrew_at

    // isInvited()
    // isInterested
    // isActive
    // isCompleted
    // isProposing
    // isPendingContract
    // isWithdrawn
    // isLost
    // isRejected
    // isAvailable
    // isOnHold

    const isEditingCoverLetter = useMemo(() => {
        return isActive && searchParams.get('tabView') === 'cover-letter'
    }, [isActive, searchParams.get('tabView')]);

    const isEditingRelevantExp = useMemo(() => {
        return isActive && searchParams.get('tabView') === 'relevant-experience'
    }, [isActive, searchParams.get('tabView')]);

    const openTab = (tab) => {
        let params = new URLSearchParams(searchParams);
        params.set('tabView', tab);
        return setSearchParams(params, {replace: true})
    }

    const editCoverLetter = async () => {
        await onToggle();
        return openTab('cover-letter')
    }

    const editRelevantExp = async () => {
        await onToggle();
        return openTab('relevant-experience')
    }

    const showInterviews = async () => {
        await onToggle();
        return openTab('interviews')
    }

    let totalSteps = teamOpp.team?.disciplines?.length;
    let steps = [];
    let matchColor = !isAvailable ? TB.config('color.danger') :TB.config('color.info');
    let matched = 0
    TB.map(TB.orderBy(teamOpp.team?.disciplines, dis => !!dis.talent_opp, 'desc'), dis => {
        if (dis.talent_opp) {
            matched += 1;
        }
        steps.push(dis.talent_opp ? matchColor : TB.config('color.gray'))
    })
    // TB.map(TB.range(record.total_accepted_talent_opps), result => {
    //     steps.push(TB.config('color.info'))
    // })
    // TB.map(TB.range(record.total_proposed_talent_opps), result => {
    //     steps.push(TB.config('color.warning'))
    // })
    // TB.map(TB.range(record.total_rejected_talent_opps), result => {
    //     steps.push(TB.config('color.danger'))
    // })
    // TB.map(TB.range(record.total_withdrawn_talent_opps), result => {
    //     steps.push(TB.config('color.danger-darker'))
    // })
    // TB.map(TB.range(record.total_pending_talent_opps), result => {
    //     steps.push(TB.config('color.gray'))
    // })

    return (
        <div>
            <div className="flex flex-row flex-wrap gap-3">
                <div className="flex-1 flex flex-row items-center gap-3">
                    {/*<p className="text-sm font-semibold whitespace-nowrap">*/}
                    {/*    {record.name}*/}
                    {/*</p>*/}
                    <p className="text-sm font-semibold whitespace-nowrap">
                        {teamOpp.team?.name}
                    </p>
                    <div className="flex flex-row items-center">
                        {teamOpp.team?.positions?.length > 0 && TB.map(TB.take(teamOpp.team?.positions, 3), position => (
                            <div className="ml-[-3px]"
                                 key={`tp-${teamOpp.id}-ps-${position.id}-${teamOpp.team.id}`}>
                                <UserImageCircle
                                    user={position} size={28}
                                    className="img-fluid img-grayscale border border-white"/>
                            </div>
                        ))}
                        {teamOpp.team?.positions?.length > 3 && (
                            <div className="ml-[-3px]">
                                <div className="user-image-circle w-7 h-7 bg-blue-100">
                                    <div className="initials text-info">
                                        + {teamOpp.team.positions.length - 3}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>



                {/*<div className="flex items-center justify-start w-[110px]">*/}
                {/*    <Badge*/}
                {/*        count={talentUserOpp?.id ? talentUserOpp.display_status : (talentUserOpp.is_match ? 'Match' : 'No Match')}*/}
                {/*        color={talentUserOpp.statusColor()}/>*/}
                {/*</div>*/}
                {isAvailable && teamOpp.job_candidate?.has_confirmed_scope && (
                    <div className="flex mr-auto items-center flex-row flex-nowrap">
                        <button type="button" onClick={() => {
                            onToggle();
                        }} disabled={!teamOpp.canMessageAndAcceptInterviews()}
                                className={TB.mapClass("p-3 relative", {
                                    'opacity-0': !teamOpp.canMessageAndAcceptInterviews()
                                })}>
                            {teamOpp.canMessageAndAcceptInterviews() && !!teamOpp.job_candidate?.unread_messages_count && (
                                <Badge count={teamOpp.job_candidate.unread_messages_count} size="small"
                                       className="absolute top-0 right-0.5"/>
                            )}
                            <i className="fas fa-comment-alt text-lg text-light-gray6"/>
                        </button>
                        <button type="button" onClick={showInterviews}
                                disabled={!teamOpp.canMessageAndAcceptInterviews()}
                                className={TB.mapClass("p-3 relative", {
                                    'opacity-0': !teamOpp.canMessageAndAcceptInterviews()
                                })}>

                            {teamOpp.canMessageAndAcceptInterviews() &&
                                (!!teamOpp.job_candidate?.upcoming_meetings_count || !!teamOpp.job_candidate?.proposed_meetings_count) && (
                                    <Badge
                                        count={teamOpp.job_candidate.upcoming_meetings_count + teamOpp.job_candidate.proposed_meetings_count}
                                        size="small" className="absolute top-0 right-0.5"/>
                                )}
                            <i className="fas fa-calendar-alt text-lg text-light-gray6"/>
                        </button>
                    </div>
                )}

                <div className="flex items-center flex-1 flex-row gap-4 justify-end">
                    <div className="flex flex-row gap-1 items-center flex-nowrap">
                        {steps?.length > 0 ? (
                            <React.Fragment>
                                {TB.map(steps, (step, ind) => {
                                    // const bgColor = record.hasConfirmedPayout() ? TB.config('color.success-dark') : step
                                    return (
                                        <div style={{background: step}} key={ind}
                                             className="h-3 w-6"/>
                                    )
                                })}

                                <p className="text-xxs whitespace-nowrap">
                                    {`${matched} / ${totalSteps} roles assigned`}
                                </p>
                            </React.Fragment>
                        ) : (
                            <p className="text-xs">
                                <i>Scoping Required</i>
                            </p>
                        )}
                    </div>

                    {isAvailable ? (
                        <Link to={`${teamOpp.job_candidate?.id}`}
                           className={TB.mapClass("btn py-1.5 text-xs px-2 flex flex-row gap-1 items-center", {
                               "btn-primary": teamOpp.job_candidate?.has_confirmed_scope,
                               "btn-outline-dark": !teamOpp.job_candidate?.has_confirmed_scope
                           })}>
                            {!teamOpp.job_candidate?.has_confirmed_scope && (
                                <i className="fas fa-exclamation-circle"/>
                            )}
                            <span>Manage Scope</span>
                        </Link>
                    ) : (
                        <Badge
                            count={teamOpp.job_candidate?.is_rejected ? 'Passed Opportunity' : (teamOpp?.job_candidate?.is_withdrawn ? 'Withdrew from Opportunity' : (
                                teamOpp.is_dead && "Lost"
                            ))}
                            color={TB.config('color.danger')}/>
                    )}
                </div>


                <div className="flex items-center justify-end gap-2">

                    {!teamOpp.is_dead && teamOpp.can_be_rejected && (
                        <button
                            type="button"
                            disabled={isDisabled}
                            onClick={() => toggleRejectionModal()} className="btn py-1.5 text-xs px-2 btn-dark text-white">
                            Pass
                        </button>
                    )}

                    {!teamOpp.is_dead && teamOpp.isAccepted() && teamOpp.isPendingContract() && teamOpp.has_signable_contract && (
                        <button
                            type="button"
                            disabled={isDisabled}
                            onClick={() => toggleRejectionModal()} className="btn py-1.5 text-xs px-2 btn-secondary text-white">
                            Review Contract and Signed
                        </button>
                    )}
                    {!teamOpp.is_dead && teamOpp.isAccepted() && teamOpp.can_be_withdrawn && (
                        <button
                            type="button"
                            disabled={isDisabled}
                            onClick={() => toggleRejectionModal()} className="btn py-1.5 text-xs px-2 btn-dark text-white">
                            Withdraw
                        </button>
                    )}

                </div>
            </div>

            <div className="rounded-lg p-4 mt-4 border-wrippleLightGrayBg border-solid bg-[#FAFBFC] border-[1px]">
                <p className="text-bold text-wripplePrimaryDarkNavy">Project Proposal</p>

                <div className="flex pt-4">

                    <div className="flex-1">
                        <p className="text-xs text-wripplePrimaryDarkNavy whitespace-nowrap">
                            Contract Value
                        </p>
                        <div className="flex flex-row gap-1.5 items-center flex-nowrap">
                            <p>
                                {teamOpp.id ? TB.formatCurrency(teamOpp.job_candidate?.payout_amount, false) : 'TBD'}
                            </p>
                        </div>
                    </div>

                    <div className="flex-1">
                        <p className="text-xs text-wripplePrimaryDarkNavy whitespace-nowrap">
                            Estimated Start
                        </p>
                        <div className="flex flex-row gap-1.5 items-center flex-nowrap">
                            <p>
                                {TB.moment(teamOpp.project?.anticipatedStart()).format('M/D/YYYY')}
                            </p>
                        </div>
                    </div>

                    <div className="flex-1">
                        <p className="text-xs text-wripplePrimaryDarkNavy whitespace-nowrap">
                            <span>
                                Cover Letter
                            </span>
                        </p>
                        <p>
                            <span className="flex flex-row items-center flex-nowrap gap-1.5">


                                {editProposalDisabled ?
                                    '---' : (
                                        <React.Fragment>
                                            <i className={TB.mapClass("fas text-[16px]", {
                                                "fa-check text-success": teamOpp.job_candidate?.cover_letter?.length > 0,
                                                "fa-times text-black": !teamOpp.job_candidate?.cover_letter?.length,
                                            })}/>
                                            {/*{teamOpp.job_candidate?.cover_letter?.length > 0 ? (*/}
                                            {/*    <span className="inline">*/}
                                            {/*        {TB.truncate(teamOpp.job_candidate?.cover_letter.replace(/<[^>]*>?/gm, ''), {length: 15})}*/}
                                            {/*    </span>*/}
                                            {/*) : (*/}
                                            {/*    <span className="inline">*/}
                                            {/*        --*/}
                                            {/*    </span>*/}
                                            {/*)}*/}
                                            {!editProposalDisabled && !isEditingCoverLetter && !teamOpp.is_dead && teamOpp.id && (
                                                <button onClick={editCoverLetter} disabled={isDisabled}
                                                        className="btn-link btn-link-info py-0">
                                                    Edit
                                                </button>
                                            )}
                                        </React.Fragment>
                                    )}
                            </span>
                           </p>
                    </div>

                    <div className="flex-1">
                        <p className="text-xs text-wripplePrimaryDarkNavy whitespace-nowrap">
                            <span>
                                Relevant Experience
                            </span>
                        </p>
                        <p>
                            <span className="flex flex-row items-center flex-nowrap gap-1.5">
                                {editProposalDisabled ?
                                    '---' : (
                                        <React.Fragment>
                                            <i className={TB.mapClass("fas text-[16px]", {
                                                "fa-check text-success": teamOpp.job_candidate?.relevant_experience?.length > 0,
                                                "fa-times text-black": !teamOpp.job_candidate?.relevant_experience?.length,
                                            })}/>
                                            {/*{teamOpp.job_candidate?.relevant_experience?.length > 0 ? (*/}
                                            {/*        <span className="inline">*/}
                                            {/*        {TB.truncate(teamOpp.job_candidate?.relevant_experience.replace(/<[^>]*>?/gm, ''), {length: 15})}*/}
                                            {/*    </span>*/}
                                            {/*) : (*/}
                                            {/*    <span className="inline">*/}
                                            {/*        --*/}
                                            {/*    </span>*/}
                                            {/*)}*/}
                                            {!editProposalDisabled && !isEditingRelevantExp && !teamOpp.is_dead && teamOpp.id && (
                                                <button onClick={editRelevantExp} disabled={isDisabled}
                                                        className="btn-link btn-link-info py-0">
                                                    Edit
                                                </button>
                                            )}
                                        </React.Fragment>
                                    )}

                            </span>

                        </p>
                    </div>
                </div>
            </div>
            <Modal
                ref={rejectModal}
                modalClass={"opp-reject-feedback-modal"}
                title="Sorry this project doesn't fit your talent's needs."
                onCloseAction={async () => {
                    console.log('onClose Action')
                }}>

                <OppRejectionFeedbackModal
                    onCancel={() => rejectModal.current.hideModal(true)}
                    disabled={isDisabled}
                    onSubmit={async (model) => {
                        await rejectModal.current.hideModal(true);


                        if (teamOpp.can_be_rejected) {
                            return rejectOpp(model)
                        }

                        if (teamOpp.can_be_withdrawn) {
                            return withdrawOpp(model)
                        }
                    }}
                />
            </Modal>
        </div>
    )
}

export default CollapseTeamsHeader;